import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import CSVReader from "react-csv-reader";
import Rest from "../../services/Rest";
import { withRouter } from "react-router-dom";
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import '../../css/estilos.css'

const stateInicial = {
    campana: {
        id_camp: 0,
        nombre: "",
        fechaInicio: "",
        fechaFinalizacion: "",
        habilitarCamp: 0,
        horaInicio: "",
        horaFinalizacion: "",
        mensaje: "",
        diasDeLaSemana: [],
        habilitarResp: 0,
        checkedHabCamp: false,
        checkedHabResp: false,
        datoscsv: [],
        respuestas: [],
        pathfile: "",
        currentFile:""
    },
    nuevasCampanas: [],
    success: false,
    successEdit: false,
    error: false,
    messageError: "",
    dias: ["L", "M", "X", "J", "V", "S", "D"],
    charTextArea: 150,
    charTextAreaRespuesta: [],
    showLoaderFile:false,
    errorIcon:false,
    errorIconTxt: "",
    isHovering: false
}

class Formnvacamp extends Component {

    constructor(props) {
        super(props)
        this.Rest = new Rest();
        this.datauser = JSON.parse(localStorage.getItem("ls")) || [];
        //this.endpointUpload = "http://smsmasivos.local/api/v1/csv/upload";
        //this.endpointUpload = 'http://smsrapidos.itrcenter.com/api/v1/csv/upload';
        this.endpointUpload="http://srv1.smsrapidos.com/api/v1/csv/upload";
        this.changeAlert = this.changeAlert.bind(this);
    }

    state = { ...stateInicial }

    //cuando la app carga
    componentDidMount() {

        if (typeof this.props.idCamp !== "undefined") {

            this.Rest.get("campanas/" + this.props.idCamp, this.datauser)
                .then(response => {
                    if (response.status === 200) {
                        let campinfo = response.data.campana;
                        this.setState({
                            campana: {
                                id_camp: campinfo.id_camp,
                                nombre: campinfo.nombre,
                                fechaInicio: campinfo.fechaInicio,
                                fechaFinalizacion: campinfo.fechaFinalizacion,
                                habilitarCamp: campinfo.habilitarCamp,
                                horaInicio: campinfo.horaInicio,
                                horaFinalizacion: campinfo.horaFinalizacion,
                                mensaje: campinfo.mensaje,
                                diasDeLaSemana: campinfo.dias != null ? campinfo.dias : [],
                                habilitarResp: campinfo.habilitarResp,
                                checkedHabCamp: response.data.campana.habilitarCamp === "1" ? true : false,
                                checkedHabResp: response.data.campana.habilitarResp === "1" ? true : false,
                                datoscsv: campinfo.datoscsv || [],
                                respuestas: campinfo.respuestas || [],
                                currentFile: campinfo.archivo
                            },
                            charTextArea: response.data.campana.habilitarAcento === "1" ? 70-response.data.campana.mensaje.length : 150-response.data.campana.mensaje.length,
                        })
                    }
                    else {
                        if (response.status === 404) {
                            localStorage.removeItem("ls");
                            window.location = window.location.origin;
                        }
                        else {
                            this.setState({
                                error: true,
                                messageError: response.message
                            })
                        }
                    }
                })
        }
    }


    handleChangeTextArea = (e) => {
        let textReg = new RegExp('[áéíóúÁÉÍÓÚ]')
        let charTextAreaRespuesta = [...this.state.charTextAreaRespuesta]
        let error;
        let errorTxt;
        const acento = e.target.value.match(textReg)
        if(acento){
            charTextAreaRespuesta = (70 - (e.target.value.length))
            error = true
            errorTxt = "https://img.icons8.com/officel/16/000000/high-risk.png"
        }else{
            charTextAreaRespuesta = (150 - (e.target.value.length))
            error = false
            errorTxt = ""
        }
        this.setState({
            campana: {
                ...this.state.campana,
                [e.target.name]: e.target.value
            },
            charTextArea: charTextAreaRespuesta,
            errorIcon: error,
            errorIconTxt: errorTxt
        })



    }

    handleChange = e => {
        this.setState({
            campana: {
                ...this.state.campana,
                [e.target.name]: e.target.value
            }
        })
    }


    handleCheck = (e) => {

        if (this.state.campana.checkedHabCamp) {
            this.setState({
                campana: {
                    ...this.state.campana,
                    habilitarCamp: 0,
                    checkedHabCamp: false
                }
            })
        }
        else {
            this.setState({
                campana: {
                    ...this.state.campana,
                    habilitarCamp: 1,
                    checkedHabCamp: true
                }
            })
        }
    }

    handleCheckResp = (e) => {
        if (this.state.campana.checkedHabResp) {
            this.setState({
                campana: {
                    ...this.state.campana,
                    habilitarResp: 0,
                    checkedHabResp: false,
                    respuestas: []
                }
            })
        }
        else {
            let nuevaRespuesta;
            let arrRespuestas = {
                clave: "",
                respuesta: ""
            }

            nuevaRespuesta = [...this.state.campana.respuestas, arrRespuestas];
            this.setState({
                campana: {
                    ...this.state.campana,
                    habilitarResp: 1,
                    checkedHabResp: true,
                    respuestas: nuevaRespuesta
                }
            })

        }
    }

    handleChangeDays = e => {

        let arrayCopy = [...this.state.campana.diasDeLaSemana];
        let index = arrayCopy.indexOf(e.target.value);
        if (index !== -1) {
            arrayCopy.splice(index, 1);
            this.setState({
                campana: {
                    ...this.state.campana,
                    diasDeLaSemana: arrayCopy
                }
            })
        }
        else {
            const addDay = [...this.state.campana.diasDeLaSemana, e.target.value];
            this.setState({
                campana: {
                    ...this.state.campana,
                    diasDeLaSemana: addDay
                }
            })
        }
    }

    changeAlert() {
        this.setState(this.toggleHoverstate)
    }

    toggleHoverstate(state){
        return {
            isHovering: !state.isHovering,
        }
    }

    handleSubmit = (e) => {


        e.preventDefault();


        //extraer los valores de la nueva campaña
        const { nombre, fechaInicio, fechaFinalizacion, horaInicio, horaFinalizacion, mensaje, diasDeLaSemana, pathfile } = this.state.campana;


        if (nombre === ""
            || fechaInicio === ""
            || fechaFinalizacion === ""
            || horaInicio === ""
            || horaFinalizacion === ""
            || mensaje === ""
            || pathfile === "") {
            this.setState({
                error: true,
                messageError: "Todos los campos son requeridos"
            });
            return;
        }
        if (diasDeLaSemana.length <= 0) {
            this.setState({
                error: true,
                messageError: "Seleccione al menos un día de la semana para habilitar la campaña"
            });
            return;
        }
        if (this.props.idCamp)
            this.guardarEditarCampaña();
        else
            this.guardarNvaCampaña();

    }

    guardarEditarCampaña() {


        this.setState({
            error: false,
            messageError: ""
        })


        this.refs.btnGuardarCamp.setAttribute('disabled', 'disabled');
        this.refs.btnGuardarCamp.innerHTML = "Guardando...";

        this.Rest.post(this.state.campana, "campanas/actualizar", "campana", this.datauser)
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        successEdit: true
                    })
                    this.props.history.push("/lista-de-campañas")
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: response.message
                        })
                        this.refs.btnGuardarCamp.removeAttribute('disabled');
                        this.refs.btnGuardarCamp.innerHTML = "Guardar";
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    messageError: "Error de respuesta del servidor"
                })
                this.refs.btnGuardarCamp.removeAttribute('disabled');
                this.refs.btnGuardarCamp.innerHTML = "Guardar";
            })
    }



    guardarNvaCampaña = async () => {

        this.setState({
            error: false,
            messageError: ""
        })

        this.refs.btnGuardarCamp.setAttribute('disabled', 'disabled');
        this.refs.btnGuardarCamp.innerHTML = "Guardando...";

        this.Rest.post(this.state.campana, "campanas", "campana", this.datauser)
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        success: true
                    })
                    this.refs.btnGuardarCamp.removeAttribute("disabled");
                    this.props.history.push("/lista-de-campañas")
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: response.message
                        })
                        this.refs.btnGuardarCamp.removeAttribute('disabled');
                        this.refs.btnGuardarCamp.innerHTML = "Guardar";
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    messageError: "Error de respuesta del servidor"
                })
                this.refs.btnGuardarCamp.removeAttribute('disabled');
                this.refs.btnGuardarCamp.innerHTML = "Guardar";
            })

    }


    onChangeHandler = event => {
        this.setState({
            showLoaderFile:true
        })
        const data = new FormData();
        data.append('archivocsv', event.target.files[0]);
        fetch(this.endpointUpload, {
            method: 'POST',
            body: data
        })
            .then(response => response.json())
            .then(file => {


                if(file.error){
                    this.setState({
                        error: true,
                        messageError: file.error,
                        showLoaderFile:false
                    })
                    return;
                }
                else{
                    this.setState({
                        error:false,
                        messageError:"",
                        showLoaderFile:false
                    },()=>{
                        
                        let headersLength = file.csv[0].length - 1;
                        let message = "Use los campos entre llaves ";
                        for (let i = 0; i <= headersLength; i++) {
                            message += "{" + file.csv[0][i] + "}, ";
                        }
                        message += " para crear su mensaje."
                        this.setState({
                            campana: {
                                ...this.state.campana,
                                datoscsv: file.csv,
                                mensaje: message,
                                pathfile: file.file
                            }
                        })

                    })
                }

            })
    }


    

    dismiss() {
        this.setState({
            success: false,
            error: false,
            messageError: "",
            successEdit: false
        })
    }

    masRespuestas = e => {
        this.setState((prevState) => ({
            campana: {
                ...this.state.campana,
                respuestas: [...this.state.campana.respuestas, { clave: "", respuesta: "" }]
            }
        }))
    }

    handleRespuestas = e => {
        let respuestas = [...this.state.campana.respuestas]
        respuestas[e.target.dataset.id][e.target.className] = e.target.value
        this.setState({
            respuestas

        }, () => console.log(this.state.campana.respuestas))
    }

    handleRespuestasTextArea = e => {
        let respuestas = [...this.state.campana.respuestas]
        let charTextAreaRespuesta = [...this.state.charTextAreaRespuesta]
        respuestas[e.target.dataset.id][e.target.className] = e.target.value
        charTextAreaRespuesta[e.target.dataset.id] = (150 - (e.target.value.length))
        this.setState({
            respuestas,
            charTextAreaRespuesta
        }, () => console.log(this.state.campana.respuestas))
    }

    remove = index => {
        this.setState({
            campana: {
                ...this.state.campana,
                respuestas: this.state.campana.respuestas.filter((_, i) => i !== index)
            }
        });
    }

    handleTInicia = value => {
        this.setState({
            campana: {
                ...this.state.campana,
                horaInicio: value.format('HH:mm:ss')
            }
        })
    }
    handleTFinaliza = value => {
        this.setState({
            campana: {
                ...this.state.campana,
                horaFinalizacion: value.format('HH:mm')
            }
        })
    }





    render() {
        const { showLoaderFile, error, dias, success, successEdit, messageError, charTextArea,errorIconTxt } = this.state
        return (
            <Fragment>
                {showLoaderFile && 
                    <div className="uploader">
                    <div className="uploader-icon">
                        <p className="text-center">Subiendo archivo csv...</p>
                        <p className="text-center"><i className="fas fa-spinner fa-spin"></i></p>
                    </div>
                </div>
                }
                <form onSubmit={this.handleSubmit} autoComplete="off">
                    <div className="row">
                        <div className="col-md-4">
                            <label>Nombre de la campaña</label>
                            <input
                                name="nombre"
                                id="nombre"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.campana.nombre || ""}
                            ></input>
                        </div>
                        <div className="col-md-4">
                            <label>Fecha de inicio</label>
                            <input type="date" name="fechaInicio" id="fechaInicio" className="form-control"
                                onChange={this.handleChange}
                                value={this.state.campana.fechaInicio || ""} />
                        </div>
                        <div className="col-md-4">
                            <label>Fecha de finalización</label>
                            <input type="date" name="fechaFinalizacion" id="fechaFinalizacion" className="form-control"
                                onChange={this.handleChange}
                                value={this.state.campana.fechaFinalizacion || ""} />
                        </div>
                    </div>
                    <div className="mt-4"></div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Días de la semana</label>

                            <ul className="list-inline">
                                {dias.map(dia => (
                                    <li key={dia} className="list-inline-item">
                                        <label className="checkbox">
                                            <input type="checkbox" name="diasDeLaSemana" id="diasDeLaSemana" value={dia} onChange={this.handleChangeDays} checked={this.state.campana.diasDeLaSemana.find(function (element) {
                                                if (element === dia)
                                                    return true;
                                            })} /> {dia}
                                        </label>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="col-md-4">
                            <label>Hora de inicio</label>
                            <TimePicker
                                onChange={this.handleTInicia}
                                id="horaInicio"
                                showSecond={false}
                                defaultValue={this.state.campana.horaInicio}
                            />
                        </div>
                        <div className="col-md-4">
                            <label>Hora de finalización</label>
                            <TimePicker
                                id="horaFinalizacion"
                                onChange={this.handleTFinaliza}
                                showSecond={false}
                                defaultValue={this.state.campana.horaFinalizacion}
                            />
                        </div>
                    </div>

                    <div className="mt-2"></div>
                    <div className="row">
                        <div className="col-md-4">
                            <input type="file" name="file" onChange={this.onChangeHandler} />
                            {this.state.campana.currentFile!==""?
                            <p className="text-info"><small>Esta campaña ya cuenta con un archivo csv</small></p>
                            : <p className="text-danger"><small>Esta campaña no cuenta con archivo csv</small></p>}
                        </div>
                        <div className="col-md-8">
                            {this.state.campana.datoscsv.length > 0 ?
                                <div className="table-responsive tblmx">
                                    <table className="table table-bordered table-condensed table-striped">
                                        <tbody>
                                            <tr>
                                                {this.state.campana.datoscsv[0].map((datos, index) => (

                                                    <td key={index}>{datos}</td>

                                                ))}
                                            </tr>
                                            <tr>
                                                {this.state.campana.datoscsv[1].map((datos, index) => (

                                                    <td key={index}>{datos}</td>

                                                ))}
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                :
                                null}
                        </div>
                    </div>
                    <div className="mt-2"></div>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Mensaje</label>

                            <textarea
                                className="form-control"
                                name="mensaje"
                                id="mensaje"
                                rows="6"
                                onChange={this.handleChangeTextArea}
                                value={this.state.campana.mensaje || ""}
                                placeholder={this.state.message}
                                maxLength={150}></textarea>
                            <div className="d-flex">

                                <div className="ml-auto">
                                    <p><b><img src={errorIconTxt} onMouseEnter={this.changeAlert} onMouseLeave={this.changeAlert} onMouseOver={this.changeAlert}/>{this.state.isHovering && <div className="alert-danger alertDiv">Capacidad de cáracteres reducida débido a uso de cáracteres especiales</div> } {charTextArea} caracteres restantes</b></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-2"></div>
                    <div className="row">
                        <div className="col-md-4">

                            <div className="custom-control custom-switch">

                                {this.state.campana.habilitarCamp === "1" ?
                                    <input type="checkbox" className="custom-control-input" id="habilitarCamp" name="habilitarCamp" value={this.state.campana.habilitarCamp} onChange={this.handleCheck} defaultChecked={this.state.campana.checkedHabCamp} checked />
                                    :
                                    <input type="checkbox" className="custom-control-input" id="habilitarCamp" name="habilitarCamp" value={this.state.campana.habilitarCamp} onChange={this.handleCheck} defaultChecked={this.state.campana.checkedHabCamp} />
                                }
                                <label className="custom-control-label" htmlFor="habilitarCamp">Habilitar campaña</label>
                            </div>

                        </div>
                    </div>

                    <div className="row">

                        <div className="col-md-12">
                            <div className="custom-control custom-switch">
                                {this.state.campana.habilitarResp === "1" ?

                                    <input type="checkbox" className="custom-control-input" id="habilitarResp" name="habilitarResp" value={this.state.campana.habilitarResp} onChange={this.handleCheckResp} defaultChecked={this.state.campana.checkedHabResp} checked />
                                    :
                                    <input type="checkbox" className="custom-control-input" id="habilitarResp" name="habilitarResp" value={this.state.campana.habilitarResp} onChange={this.handleCheckResp} defaultChecked={this.state.campana.checkedHabResp} />
                                }

                                <label className="custom-control-label" htmlFor="habilitarResp">Habilitar respuestas</label>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-12">
                            {this.state.campana.checkedHabResp !== false ?
                                <Fragment>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="text-right">
                                                <button onClick={() => this.masRespuestas()} type="button" className="btn btn-info btn-sm">
                                                    <i className="fas fa-plus"></i> Agregar respuestas
                                            </button>
                                            </div>
                                        </div>
                                    </div>

                                    {typeof this.state.campana.respuestas !== "undefined" && this.state.campana.respuestas.length > 0 ?
                                        this.state.campana.respuestas.map((value, index) => (
                                            <div className="row mt-2" key={index}>
                                                <div className="col-md-4">
                                                    <label>Palabra clave</label>

                                                    <input type="text"
                                                        name={"clave" + index}
                                                        id={"clave" + index}
                                                        data-id={index}
                                                        className="clave"
                                                        value={this.state.campana.respuestas[index].clave || ""}
                                                        onChange={this.handleRespuestas} maxLength={50} />

                                                </div>
                                                <div className="col-md-6">
                                                    <label>Mensaje de respuesta automatizado</label>

                                                    <textarea
                                                        className="respuesta"
                                                        name={"respuesta" + index}
                                                        id={"respuesta" + index}
                                                        data-id={index} rows="5"
                                                        value={this.state.campana.respuestas[index].respuesta || ""}
                                                        onChange={this.handleRespuestasTextArea} maxLength={150} ></textarea>
                                                    <div className="d-flex">
                                                        <div className="ml-auto">
                                                            <p><b>{this.state.charTextAreaRespuesta[index]} caracteres restantes</b></p>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="col-md-2">
                                                    <button type="button" className="mt-4 btn btn-danger btn-sm btn-block" onClick={() => this.remove(index)}>
                                                        <i className="fas fa-times"></i> Borrar respuesta
                                            </button>
                                                </div>
                                            </div>
                                        ))
                                        :
                                        null
                                    }
                                </Fragment>
                                :
                                null}
                        </div>
                    </div>
                    <div className="mt-2"></div>
                    <button type="submit" className="btn btn-primary" ref="btnGuardarCamp">Guardar</button>
                    <Link to="/lista-de-campañas" className="btn btn-danger ml-3">Cancelar</Link>

                </form>
                {error ?
                    <div className="alert alert-danger alert-float">
                        <button type="button" className="close" onClick={() => this.dismiss()}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <b>{messageError}</b>
                    </div> : null}
                {success ?
                    <div className="alert alert-success alert-float">
                        <button type="button" className="close" onClick={() => this.dismiss()}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <b>Nueva campaña creada.</b>
                    </div> : null}
                {successEdit ?
                    <div className="alert alert-success alert-float">
                        <button type="button" className="close" onClick={() => this.dismiss()}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <b>Cambios realizados</b>
                    </div> : null}
            </Fragment>
        );
    }
}

export default withRouter(Formnvacamp);


// WEBPACK FOOTER //
// ./src/components/campaigns/Formnvacamp.js